export const HEADER_HEIGHT = '90px'
export const TODAY = 'today'
export const TOMORROW = 'tomorrow'
